import { toLevel } from "utils/actionGrouping";
import { getTaskLabelIds } from "utils/actionLabels";

export const EMPTY_ACTION_FILTERS = {
  priorities: [],
  efforts: [],
  labelIds: [],
  sources: [],
  hasFiles: false,
};

export const SOURCE_FILTER_OPTIONS = [
  { value: "mine", label: "Added by me" },
  { value: "assigned", label: "Assigned to me" },
  { value: "meeting", label: "From a meeting" },
];

const ENTITIES = { "&amp;": "&", "&lt;": "<", "&gt;": ">", "&quot;": '"', "&#39;": "'", "&nbsp;": " " };

// Plain text of an action's html, for search and for the one-line title.
export const getActionText = (html) =>
  String(html || "")
    .replace(/<\/(p|div|li|h\d)>|<br\s*\/?>/gi, " ")
    .replace(/<[^>]+>/g, "")
    .replace(/&(amp|lt|gt|quot|#39|nbsp);/g, (entity) => ENTITIES[entity])
    .replace(/\s+/g, " ")
    .trim();

export const isAssignedByOther = (task) =>
  !!task?.assigned?.by && task.assigned.by !== "self";

const getSourceKind = (task) => {
  if (task?.source?.type === "meeting_summary") return "meeting";
  if (isAssignedByOther(task)) return "assigned";
  return "mine";
};

const matchesSearch = (task, query) => {
  const haystack = [
    getActionText(task.html),
    task?.assigned?.by,
    task?.assigned?.to,
    task?.source?.meetingTitle,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
  return haystack.includes(query);
};

// Number shown on the Filter button. Search and visibility have their own
// controls, so they do not count.
export const countActiveFilters = (filters = EMPTY_ACTION_FILTERS) =>
  (filters.priorities?.length || 0) +
  (filters.efforts?.length || 0) +
  (filters.labelIds?.length || 0) +
  (filters.sources?.length || 0) +
  (filters.hasFiles ? 1 : 0);

export const applyActionFilters = (
  items,
  { search = "", visibility = "both", ...filters } = {}
) => {
  const query = search.trim().toLowerCase();
  const {
    priorities = [],
    efforts = [],
    labelIds = [],
    sources = [],
    hasFiles = false,
  } = filters;

  return items.filter((task) => {
    if (visibility === "public" && task.private) return false;
    if (visibility === "private" && !task.private) return false;
    if (priorities.length && !priorities.includes(toLevel(task.priority)))
      return false;
    if (efforts.length && !efforts.includes(toLevel(task.effort))) return false;
    if (
      labelIds.length &&
      !getTaskLabelIds(task).some((id) => labelIds.includes(id))
    )
      return false;
    if (sources.length && !sources.includes(getSourceKind(task))) return false;
    if (hasFiles && !(task.attachments?.length > 0)) return false;
    if (query && !matchesSearch(task, query)) return false;
    return true;
  });
};
